export const NAVIGATION = {
    back: false,
    next: true,
    cancel: true,
  }